/** IDs dos canais de venda que indeitifica por qual canal estão sendo vendidos os produtos e serviços da empresa */
export enum CanalVendaID {
    DIRETO = 1,
    LOJA_VIRTUAL = 2,
    AMAZON = 3,
    AMERICANAS_MARKETPLACE = 4,
    CARREFOUR_MARKETPLACE = 5,
    CASAS_BAHIA_MARKETPLACE = 6,
    CENTAURO = 7,
    DAFITI = 8,
    MAGALU_MARKETPLACE = 9,
    MERCADO_LIVRE = 10,
    NETSHOES = 11,
    SHEIN = 12,
    SHOPEE = 13,
    FACEBOOK_SHOPS = 14,
    INSTAGRAM_SHOPING = 15,
    TIKTOK_SHOP = 16,
    WHATSAPP_BUSINESS = 17
}

export namespace CanalVendaID {
    /** Verifica se é o canal de venda Direto */
    export function isCanalVendaDireto(id: number): boolean {
        return id == CanalVendaID.DIRETO;
    }

    /** Verifica se é o canal de venda Loja Virtual */
    export function isCanalVendaLojaVirtual(id: number): boolean {
        return id == CanalVendaID.LOJA_VIRTUAL;
    }

    /** Verifica se é o canal de venda Amazon */
    export function isCanalVendaAmazon(id: number): boolean {
        return id == CanalVendaID.AMAZON;
    }

    /** Verifica se é o canal de venda Americanas Marketplace */
    export function isCanalVendaAmericanasMarketplace(id: number): boolean {
        return id == CanalVendaID.AMERICANAS_MARKETPLACE;
    }

    /** Verifica se é o canal de venda Carrefour Marketplace */
    export function isCanalVendaCarrefourMarketplace(id: number): boolean {
        return id == CanalVendaID.CARREFOUR_MARKETPLACE;
    }

    /** Verifica se é o canal de venda Casas Bahia Marketplace */
    export function isCanalVendaCasasBahiaMarketplace(id: number): boolean {
        return id == CanalVendaID.CASAS_BAHIA_MARKETPLACE;
    }

    /** Verifica se é o canal de venda Centauro */
    export function isCanalVendaCentauro(id: number): boolean {
        return id == CanalVendaID.CENTAURO;
    }

    /** Verifica se é o canal de venda Dafiti */
    export function isCanalVendaDafiti(id: number): boolean {
        return id == CanalVendaID.DAFITI;
    }

    /** Verifica se é o canal de venda Magalu Marketplace */
    export function isCanalVendaMagaluMarketplace(id: number): boolean {
        return id == CanalVendaID.MAGALU_MARKETPLACE;
    }

    /** Verifica se é o canal de venda Mercado Livre */
    export function isCanalVendaMercadoLivre(id: number): boolean {
        return id == CanalVendaID.MERCADO_LIVRE;
    }

    /** Verifica se é o canal de venda Netshoes */
    export function isCanalVendaNetshoes(id: number): boolean {
        return id == CanalVendaID.NETSHOES;
    }

    /** Verifica se é o canal de venda Shein */
    export function isCanalVendaShein(id: number): boolean {
        return id == CanalVendaID.SHEIN;
    }

    /** Verifica se é o canal de venda Shopee */
    export function isCanalVendaShopee(id: number): boolean {
        return id == CanalVendaID.SHOPEE;
    }

    /** Verifica se é o canal de venda Facebook Shops */
    export function isCanalVendaFacebookShops(id: number): boolean {
        return id == CanalVendaID.FACEBOOK_SHOPS;
    }

    /** Verifica se é o canal de venda Instagram Shopping */
    export function isCanalVendaInstagramShopping(id: number): boolean {
        return id == CanalVendaID.INSTAGRAM_SHOPING;
    }

    /** Verifica se é o canal de venda TikTok Shop */
    export function isCanalVendaTikTokShop(id: number): boolean {
        return id == CanalVendaID.TIKTOK_SHOP;
    }

    /** Verifica se é o canal de venda WhatsApp Business */
    export function isCanalVendaWhatsAppBusiness(id: number): boolean {
        return id == CanalVendaID.WHATSAPP_BUSINESS;
    }
}
